/*
 * @Author: your name
 * @Date: 2021-01-13 17:37:21
 * @LastEditTime: 2021-01-18 09:45:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\router\globalRoutes.js
 */
export default [
    {
        path: "/dev_login",
        name: "dev_login",
        component: () => import("@/views/old_mini/dev_login.vue"),
    },
    // 创建农场
    {
        path: "/create_farm",
        name: "CreateFarm",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/index.vue"),
    },
    // 农事记录
    {
        path: "/agri_record",
        name: "AgriRecord",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/agri_record/index.vue"),
    },
    // 编辑地图
    {
        path: "/edit_map",
        name: "EditMap",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/editMap.vue"),
    },
    // 聊天
    {
        path: "/chat_frame",
        name: "ChatFrame",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/chat_frame/index.vue"),
    },
    // 成果报告
    {
        path: "/achievement_report",
        name: "AchievementReport",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/achievement_report/index.vue"),
    },
    // 长势报告
    {
        path: "/growth_report",
        name: "GrowthReport",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/growth_report/index.vue"),
    },
    // 历史风险报告
    {
        path: "/history_risk_report",
        name: "HistoryRiskReport",
        component: () => import("@/views/old_mini/growth_report/historyRiskReport.vue"),
    },
    // 咨询专家
    {
        path: "/consult",
        name: "Consult",
        component: () => import("@/views/old_mini/chat_frame/consult.vue"),
    },
    // 农事互动列表
    {
        path: "/interaction_list",
        name: "InteractionList",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/interactionList/index.vue"),
    },
    // 勾画发生区域
    {
        path: "/draw_region",
        name: "DrawRegion",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/interactionList/drawRegion.vue"),
    },
    //确认区域
    {
        path: "/confirm_area",
        name: "ConfirmArea",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/interactionList/confirmArea.vue"),
    },
    //有味溯源
    {
        path: "/youwei_trace",
        name: "YouweiTrace",
        component: () => import("@/views/old_mini/youwei_trace/index.vue"),
        meta: { showTabbar: true, keepAlive: true },
    },
    // 农事详情
    {
        path: "/work_detail",
        name: "WorkDetail",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/work_detail/index.vue"),
    },
    // 农事详情 - 查看区域
    {
        path: "/view_area",
        name: "WorkViewArea",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/work_detail/components/mapInfo.vue"),
    },
    {
        path: "/select_crop",
        name: "SelectCrop",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/create_farm/selectCrop.vue"),
    },
    // 农事档案
    {
        path: "/agri_file",
        name: "AgriFile",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/agri_file/index.vue"),
    },
    // 农事记录详情
    {
        path: "/record_details",
        name: "RecordDetails",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/recordDetails/index.vue"),
    },
    // 地图管理
    {
        path: "/map_manage",
        name: "MapManage",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/recordDetails/mapManage.vue"),
    },
    // 农事详情
    {
        path: "/agri_record_detail",
        name: "AgriRecordDetail",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/agri_record_detail/index.vue"),
    },
    // 农事执行
    {
        path: "/work_execute",
        name: "WorkExecute",
        meta: { showTabbar: true, keepAlive: true },
        component: () => import("@/views/old_mini/work_execute/index.vue"),
    },
    // 农场信息
    {
        path: "/farm_info",
        name: "FarmInfo",
        meta: { keepAlive: true },
        component: () => import("@/views/old_mini/farm_info/index.vue"),
    },
];
